import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { Alert } from 'src/app/classes/alert';
import { BaseClass } from 'src/app/classes/base_class';
import { RealClub, RealClubResponse } from 'src/app/classes/real_club';
import { RealPlayer, RealPlayerResponse } from 'src/app/classes/real_player';
import { User, UserResponse } from 'src/app/classes/user';
import { AbstractService } from 'src/app/services/abstract.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { eventNames } from 'process';
import { toInt } from 'ngx-bootstrap/chronos/utils/type-checks';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-single',
  templateUrl: './single.component.html',
  styleUrls: ['./single.component.scss']
})
export class SingleComponent implements OnInit {
  busy: Subscription;
  faPlus = faSave;
  rels: Array<any>;
  singleResponse: UserResponse | RealClubResponse | RealPlayerResponse;
  cols: any;
  roles: any;
  @Input() id: number;
  @Input() single: User | RealClub | RealPlayer;
  @Input() componentService: AbstractService;
  @Input() routePart: string;
  @Input() routeSingleDescription: string;
  @Output() pathListEvent = new EventEmitter<any[]>();
  @ViewChild('alertbox1', { static: false }) alertbox1: AlertboxComponent;
  user: any
  constructor(private router: Router, private userService: UserService) { }

  ngOnInit(): void {
    this.getRoles()
    this.getSingle(this.id);
    
  }

  getControlType(control_name: string): string {
    if (control_name in this.single.controls) {
      return this.single.controls[control_name];
    }
    return '';
  }
  getRoles(){
    this.busy = this.userService.getUserRoles().subscribe({
        next: (data) => {
          this.roles = data.payload
        },
        error: (err) => console.log(err),
    });
  }
  getSingle(id: number) {
    const isNew = id == 0 ? true : false;
    if (id == 0) id = 1;
    this.busy = this.componentService.get(id).subscribe(
      (data: UserResponse | RealClubResponse | RealPlayerResponse) => {
        if (!isNew) {
          for (const key in data.payload) {
            if (Object.prototype.hasOwnProperty.call(this.single, key)) {
              this.single[key] = data.payload[key];
            }
          }
        }

        const cols_to_delete = ['role', 'admin'];
        this.cols = data.admin_info.cols.filter((c) => c.indexOf('.') == -1 && !cols_to_delete.includes(c)); // rimuovo i campi fk e i ruoli
        console.log(this.cols)
        let path_part_1 = '';
        if (Object.prototype.hasOwnProperty.call(this.single, 'calciatore')) {
          path_part_1 = this.single['calciatore'];
        } else if (Object.prototype.hasOwnProperty.call(this.single, 'indirizzo_email')) {
          path_part_1 = this.single['indirizzo_email'];
        } else if (Object.prototype.hasOwnProperty.call(this.single, 'description')) {
          path_part_1 = this.single['description'];
        } else {
          path_part_1 = this.single['id'].toString();
        }
        this.pathListEvent.emit([path_part_1.toString(), `${this.routePart}/${this.single.id}`]);
        // for (const iterator of data.admin_info.rels) {
        //   this.getRels(iterator);
        // }
      },
      (err) => {
        // console.error(err);
        console.log('ERRORE: ' + JSON.stringify(err.error.description));
      }
    );
  }

  getRels(rel: string) {
    // this.httpdata.get('/' + rel).subscribe(
    //   (data) => {
    //     this.rels.push({ class_name: rel, list: data });
    //   },
    //   (err) => {
    //     console.error(err);
    //     alert('ERRORE: ' + JSON.stringify(err.error.description));
    //   }
    // );
  }

  getRelated(rel: string) {
    // return this.rels.find((r) => {
    //   return r.class_name == rel;
    // }).list;
  }

  saveItem() {
    const payload = BaseClass.cleanup(this.single);
    this.cleanupValues(payload)
    if (this.single.id == 0) {
      this.busy = this.componentService.create(payload).subscribe({
        next: () => {
          const provaAlert: Alert = new Alert();
          provaAlert.msg = "salvataggio riuscito";
          provaAlert.timeout = 5000;
          provaAlert.type = 'normal';
          this.alertbox1.alerts = [];
          this.alertbox1.alerts.push(provaAlert)
          this.router.navigate([`/${this.routePart}/list`]);
        },
        error: (err: HttpErrorResponse) => {
          let msg = '';
          if ('errors' in err.error) {
            msg = JSON.stringify(err.error.errors)
          } else {
            msg = err.error.status + ' - ' + err.error.payload;
          }
          const provaAlert: Alert = new Alert();
          provaAlert.msg = msg;
          provaAlert.timeout = 5000;
          provaAlert.type = 'danger';
          this.alertbox1.alerts = [];
          this.alertbox1.alerts.push(provaAlert)
        },
      });
    } else {
      this.busy = this.componentService.update(this.single.id, payload).subscribe({
        next: () => {
          const provaAlert: Alert = new Alert();
          provaAlert.msg = "Salvataggio riuscito";
          provaAlert.timeout = 5000;
          provaAlert.type = 'primary';
          this.alertbox1.alerts = [];
          this.alertbox1.alerts.push(provaAlert);
          // this.router.navigate([`/${this.routePart}/${this.single.id}`]);
        },
        error: (err: HttpErrorResponse) => {
          let msg = '';
          if ('errors' in err.error) {
            msg = JSON.stringify(err.error.errors)
          } else {
            msg = err.error.status + ' - ' + err.error.payload;
          }
          const provaAlert: Alert = new Alert();
          provaAlert.msg = msg;
          provaAlert.timeout = 5000;
          provaAlert.type = 'danger';
          this.alertbox1.alerts = [];
          this.alertbox1.alerts.push(provaAlert)
        },
      });
    }
  }
  preventDeselect(event: Event, role: number) {
    // Se clicchi sul ruolo già selezionato, previeni il comportamento di default
      if (this.single['ruolo'] === role) {
          event.preventDefault();
      }
  }
  selectRole(role: number){
    //Se il ruolo è già selezionato non permetto la deselezione
    if (this.single['ruolo'] === role) {
        return;
    }
    this.single['ruolo'] = role

    console.log(this.single['ruolo'])
  }
  cleanupValues(payload: User){
    console.log('Tipo:', typeof payload['description']);
    console.log('Valore:', payload['controls']['description']);
    console.log('È null?', payload['description'] === null);
    console.log('È undefined?', payload['description'] === undefined);
    console.log('È stringa vuota?', payload['description'] === '');

    for (const key in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, key)) {
        const value = payload[key];

        if (value === null) {
          if(payload['controls']['description'] == 'text'){
              payload[key] = ''
          }
            
        }
      }
    }
    console.log(payload)
  }
}
